import React from "react";
import { FlameIcon, GlobeIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
const TOTAL_SPOTS = 100;
export function ScarcityBar() {
  const {
    elapsed
  } = useCountdown();
  const spotsLeft = Math.max(3, 7 - Math.floor(elapsed / 90));
  const claimed = TOTAL_SPOTS - spotsLeft;
  return <div className="w-full max-w-xl" data-id="element-57" data-mp="2q2pvai4grd47">
      <div className="rounded-2xl border border-brand-amber/30 bg-paper p-4 md:p-5" data-id="element-58" data-mp="2q1o6zbyfsu4j">
        <div className="flex items-center justify-between gap-3 text-[13px] font-bold uppercase tracking-wide" data-id="element-59" data-mp="2b8urvrn2ug0e">
          <span className="flex items-center gap-1.5 text-brand-amber" data-id="element-60" data-mp="2g3gub5b6ky8c">
            <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="227mx3jjrrxb2" />
            {claimed}% claimed
          </span>
          <span className="text-brand-rose" data-id="element-62" data-mp="277977k4awxfn">Only {spotsLeft} spots left</span>
        </div>
        <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-brand-blush" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots claimed" data-id="element-63" data-mp="fgrob9frw5b">
          <div className="scarcity-stripes h-full rounded-full bg-brand-amber transition-[width] duration-300 ease-out" style={{
          width: `${claimed}%`
        }} data-id="element-64" data-mp="2zk8d6deg5g5w" />
        </div>
        <p className="mt-3 text-center text-sm leading-snug text-ink/80" data-id="element-65" data-mp="38empq87leclb">
          Only <strong className="text-brand-rose" data-id="element-66" data-mp="2knhcm0t1dyep">{spotsLeft} spots</strong> remain at the{" "}
          <strong data-id="element-67" data-mp="2gmxd4qkzqipe">$27 launch price</strong>. After that, the price goes up.
        </p>
      </div>
      <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-[13px] text-ink/65" data-id="element-68" data-mp="2ulwynpd7ihhc">
        <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-69" data-mp="2pmkejcdpzoig" />
        Your currency is converted automatically at checkout, based on your location.
      </p>
    </div>;
}